import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]
  static values = {
    searchUrl: String
  }

  connect() {
    this.lookupSequence = 0
    this.lookupTimer = null
  }

  disconnect() {
    if (this.lookupTimer) clearTimeout(this.lookupTimer)
  }

  lookup() {
    const query = this.inputTarget.value.trim()
    const sequence = ++this.lookupSequence
    if (this.lookupTimer) clearTimeout(this.lookupTimer)
    if (query.length < 2) {
      this.resultsTarget.innerHTML = ""
      return
    }

    this.lookupTimer = setTimeout(() => this.fetchMenus(query, sequence), 180)
  }

  fetchMenus(query, sequence) {
    fetch(`${this.searchUrlValue}?q=${encodeURIComponent(query)}`, {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then((response) => response.json())
      .then((payload) => {
        if (sequence !== this.lookupSequence) return

        const menus = Array.isArray(payload?.menus) ? payload.menus : []
        if (menus.length === 0) {
          this.resultsTarget.innerHTML = `<p class="pow-wow-vendor-search-note">No storefront menus found.</p>`
          return
        }

        this.resultsTarget.innerHTML = menus.map((menu) => {
          const meta = `@${menu.merchant_alias || "merchant"} · ${menu.category_count || 0} categories · ${menu.item_count || 0} items`
          if (!menu.orderable || !menu.storefront_path) {
            return `
              <button type="button" class="pow-wow-order-button" disabled>
                <strong>${this.escape(menu.name || "Untitled menu")}</strong>
                <span>${this.escape(meta)} · setup in progress</span>
              </button>
            `
          }

          return `
            <button type="button"
                    class="pow-wow-order-button"
                    data-action="click->pow-wow-vendor-search#select"
                    data-storefront-path="${this.escape(menu.storefront_path)}">
              <strong>${this.escape(menu.name || "Untitled menu")}</strong>
              <span>${this.escape(meta)} · open storefront</span>
            </button>
          `
        }).join("")
      })
      .catch(() => {
        if (sequence === this.lookupSequence) {
          this.resultsTarget.innerHTML = `<p class="pow-wow-vendor-search-note">Menu search is temporarily unavailable.</p>`
        }
      })
  }

  select(event) {
    const path = event.currentTarget.dataset.storefrontPath || ""
    if (!/^\/apay\/pwp_[A-Za-z0-9]{24}$/.test(path)) return

    window.location.assign(path)
  }

  escape(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
  }
}
